
export class SportAlgoUtils {

  /**
   * 
   * @param n number of teams
   * @param type type of the game plan
   */
  public static calcGames(n: number, type: number): number {
    let count = 0;
    for (let i = 1; i < n; i++) {
      for (let k = 0; k < n / 2; k++) {
        count += 1;
      }
    }
    return count;
  }

  /**
   * 
   * @param n group size
   * @param round hinrunde/vorrunde/3 runden/4 runden, - the number of rounds
   * @returns roundGameTable which is used for mapping
   */
  public static createGamePlan(teams: any[], n: number, plan: any, round: number = 0) {
    let gameTable = [];
    let id = 0;

    for (let i = 1; i < n; i++) {
      for (let k = 0; k < n / 2; k++) {
        let gamePlan = null;

        if (k == 0) {
          gamePlan = {
            id: new Date().getTime() + id,
            type: plan.plantype,
            gameDay: i,
            name: plan.name,
            results: "0-0",
            points: "0-0",
            winner: -1,
            time: "",
            date: "",
            played: false,
            mapping: false,
            team1: {
              results: 0,
              points: 0,
              ord: teams[((i + round) % 2 != 0) ? i - 1 : n - 1].ord,
              id: teams[((i + round) % 2 != 0) ? i - 1 : n - 1].id,
              name: teams[((i + round) % 2 != 0) ? i - 1 : n - 1].name,
              players: []
            },
            team2: {
              results: 0,
              points: 0,
              ord: teams[((i + round) % 2 != 0) ? n - 1 : i - 1].ord,
              id: teams[((i + round) % 2 != 0) ? n - 1 : i - 1].id,
              name: teams[((i + round) % 2 != 0) ? n - 1 : i - 1].name,
              players: []
            }
          }
        } else {
          let l = this.ff(i + k, n) - 1;
          let r = this.ff(i - k, n) - 1;
          // let b = ((i-k) % (n-1)) - 1;
          gamePlan = {
            id: new Date().getTime() + id,
            type: plan.plantype,
            gameDay: i,
            name: plan.name,
            results: "0-0",
            points: "0-0",
            time: "",
            date: "",
            winner: -1,
            played: false,
            mapping: false,
            team1: {
              results: 0,
              points: 0,
              ord: teams[((k + round) % 2 == 0) ? r : l].ord,
              id: teams[((k + round) % 2 == 0) ? r : l].id,
              name: teams[((k + round) % 2 == 0) ? r : l].name,
              players: []
            },
            team2: {
              results: 0,
              points: 0,
              ord: teams[((k + round) % 2 == 0) ? l : r].ord,
              id: teams[((k + round) % 2 == 0) ? l : r].id,
              name: teams[((k + round) % 2 == 0) ? l : r].name,
              players: []
            }
          }
        }
        id += 1;
        gameTable.push(gamePlan)
      }
    }

    return gameTable;
  }

  /**
   * 
   * @returns correct index of element
   */
  private static ff = (a, n) => {
    let mod = n - 1;

    if (a == 0 || a == mod) {
      return mod;
    }

    a = (a < 0) ? a + (mod * 2) : a;

    if (a < mod) {
      return (a + mod) % mod;
    }

    return a % mod;
  }

  /**
   * 
   * @param n the number of games
   * @returns the transformed array as a reversed half-piramid model
   * 1,2,3,4
   * 5,6
   * 7
   */
  public static transform(arr: number[], n: number) {
    let gameTable = [];
    let rounds = this.revertTriangle(n);
    for (let i = 0; i < rounds.length; i++) {
      let table = [];
      let sub = 0;
      for (let j = 0; j < rounds[i]; j++) {
        table.push(arr[j]);
        sub = j;
      }
      gameTable.push(table);
      arr = arr.slice(sub + 1);
    }
    return gameTable;
  }

  /**
   * 
   * @param n the number of games
   * @returns the empty array model
   * 0, 0, 0, 0
   * 0, 0
   * 0
   */
  private static revertTriangle(n) {
    let rounds = [];
    while (n >= 2) {
      n = Math.ceil(n / 2);
      rounds.push(n);
    }
    return rounds;
  }

  /**
   * 
   * @param arr nested array
   * @returns one row array
   */
  public static createOneDimArray(arr) {
    let table = [];
    if (arr && arr.length) {
      table = Object.assign([], arr);
      while (table[0].constructor === Array) {
        table = table.reduce((prev, next) => prev.concat(next));
      }
    }
    return table;
  }

  /**
   * 
   * @param arr one row array
   * @param n groups number
   * @returns nested array as a square
   * [
   *   [1,2,3]
   *   [4,5,6]
   * ]
   */
  public static createNestedArray(arr, n) {
    let gameTable = [];
    let index = 0;
    let columns = Math.floor(arr.length / n);
    for (let i = 0; i < n; i++) {
      let table = [];
      for (let j = 0; j < columns; j++) {
        table.push(arr[index]);
        index += 1;
      }
      gameTable.push(table);
    }
    return gameTable;
  }

  /**
   * 
   * @returns wrapped array
   */
  public static wrapArr(arr) {
    let wrapped = [];
    wrapped.push(arr);
    return wrapped;
  }

  public static transformJgj(plan) {
    let pairs = plan.pairs ? plan.pairs : plan.gameTable;
    plan.gameTable = SportAlgoUtils.createNestedArray(pairs, plan.rounds);
    delete plan.pairs;
    return plan;
  }

  public static transformKo(plan) {
    let pairs = plan.pairs ? plan.pairs : plan.gameTable;
    plan.gameTable = Object.assign([], SportAlgoUtils.transform(pairs, plan.games));
    delete plan.pairs;
    return plan;
  }

  public static transformVor(plan, externalArr = null) {
    let pairs;
    if(externalArr){
      pairs = Object.assign([], externalArr);
    }else{
      pairs = plan.pairs ? plan.pairs : plan.gameTable;
    }
    let gameTable = [];
    let index = 0;
    let r = plan.rounds;
    let groupNum = plan.groupNum;
    let grSize = pairs.length / r / groupNum;
    for (let i = 0; i < r; i++) {
      let table = [];
      for (let j = 0; j < groupNum; j++) {
        let array = [];
        for (let k = 0; k < grSize; k++) {
          array.push(pairs[index]);
          index += 1;
        }
        table.push(array);
      }
      gameTable.push(table);
    }
    plan.gameTable = gameTable;
    delete plan.pairs;
    return plan;
  }

  public static transformVorKo(plan) {
    let pairs = plan.pairs ? plan.pairs : plan.gameTable;
    this.transformVor(plan, pairs.filter(x => !x.mapping));
    let mappingArr = pairs.filter(x => x.mapping);
    plan.roundGameTable = this.transform(mappingArr, mappingArr.length)
    return plan;
  }

  public static transformMeKo(plan) {
    let pairs = plan.pairs ? plan.pairs : plan.gameTable;
    this.transformVor(plan, pairs.filter(x => !x.mapping));
    let mappingArr = pairs.filter(x => x.mapping);
    plan.roundGameTable = this.transform(mappingArr, mappingArr.length)
    return plan;
  }

  public static createRoundTeamsTable(plan){
    if(!plan.roundTeams){ 
      plan.roundTeams = [];
      let gN = Number(plan.groupNum);
      let gS = Number(plan.groupSize);
      let index = 0;
      for(let i = 0; i < gN; i++){
        let group = [];
        for(let j = 0; j < gS; j++){
          group.push(plan.teams[index]);
          index += 1;
        }
      
        plan.roundTeams.push(group);
      }
    }
  }

  public static squareCeil(n: number){
    let num = n;
    if(n > 4 && n <= 8){
      num = 8;
    }else if(n > 8 && n <= 16){
      num = 16;
    }else if(n > 16 && n <= 32){
      num = 32;
    }else if(n > 32 && n <= 64){
      num = 64;
    }else if(n > 64 && n <= 128){
      num = 128;
    }else if(n > 128 && n <= 256){
      num = 256;
    }
    return num;
  }
}